import { render, staticRenderFns } from "./freightSet.vue?vue&type=template&id=116446d7&scoped=true"
import script from "./freightSet.vue?vue&type=script&lang=js"
export * from "./freightSet.vue?vue&type=script&lang=js"
import style0 from "./freightSet.vue?vue&type=style&index=0&id=116446d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116446d7",
  null
  
)

export default component.exports